import { useEffect, useState } from "react"
import { Stack } from "@mui/material"
import useAppStore from "store/app"

import HistoryCard from "./Card"
import NoClientData from "../NoClientData"
import useTranslation from "../../../hooks/use_translation"

const Index = () => {
  const [anamneses, setAnamneses] = useState([])
  const { pages } = useTranslation()

  const getClientAnamneses = useAppStore((state) => state.getClientAnamneses)

  useEffect(() => {
    fetchAnamneses()
  }, [])

  const fetchAnamneses = () => {
    getClientAnamneses().then((response) => {
      setAnamneses(response.data)
    })
  }

  if (anamneses.length === 0) {
    return <NoClientData description={pages?.history_of_requests?.no_data} />
  }

  return (
    <Stack sx={{ mb: 4 }}>
      {anamneses.map((item, i) => (
        <HistoryCard key={i} data={item} />
      ))}
    </Stack>
  )
}

export default Index
